var map = {
	"./American Football.svg": 3371,
	"./Soccer.svg": 59443,
	"./app.svg": 96391,
	"./aussie.svg": 36720,
	"./aviator.svg": 66884,
	"./baseball.svg": 77354,
	"./basketball.svg": 39611,
	"./boxing.svg": 46623,
	"./casino.svg": 17039,
	"./cricket.svg": 41691,
	"./darts.svg": 86048,
	"./default.png": 70049,
	"./floorball.svg": 14935,
	"./handball.svg": 68298,
	"./home.svg": 74211,
	"./icehockey.svg": 34656,
	"./jackpot.svg": 96420,
	"./league.svg": 12093,
	"./livescore.svg": 47098,
	"./livescore1.svg": 54647,
	"./mma.svg": 10941,
	"./print.svg": 55131,
	"./promos.svg": 52966,
	"./rugby.svg": 45099,
	"./sports.svg": 82731,
	"./surecoin.svg": 30738,
	"./tennis.svg": 45019,
	"./virtuals.svg": 30078,
	"./volleyball.svg": 76434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2238;